import Holidays from 'date-holidays';
import moment from 'moment';

import { parseHolidayDay } from './holidaysCalculations';

export const UI_DATE_FORMAT_STRING = 'MM/DD/YYYY'; // used for showing dates for users
export const UI_DATE_TIME_FORMAT_STRING = 'M/DD/YYYY H:mm'; // used for showing date time for users
export const DATE_FORMAT_STRING = 'MM/DD/YYYY';
export const DB_DATE_FORMAT_STRING = 'YYYY-MM-DD';
export const DB_DATETIME_FORMAT_STRING = 'YYYY-MM-DD HH:mm';
export const TIMESTAMP_FORMAT_STRING = 'YYYY-MM-DDTHH:mm:ss';

export const parseDate = (date: string, format: string = `${DATE_FORMAT_STRING}, HH:mm A`): string => {
  return moment(date, DB_DATE_FORMAT_STRING).format(format);
};

export const parseTimestamp = (date: string, format: string = `${DATE_FORMAT_STRING}, HH:mm A`): string => {
  return moment(date, TIMESTAMP_FORMAT_STRING).format(format);
};

export const parseDateNoTime = (date: string, format: string = DATE_FORMAT_STRING): string => {
  return parseDate(date, format);
};

export const parseTimeTo = (timeTo: string): string => {
  return timeTo === '0:00' ? '23:59:59' : timeTo;
};

export const getHourFormatted = (hour: string): string => {
  return moment(`2000-01-01 ${hour}`, DB_DATETIME_FORMAT_STRING).format('h:mma');
};
export const parseTime = (datetime: string, format: string = UI_DATE_TIME_FORMAT_STRING): string => {
  return moment(datetime).format(format);
};

export const getUSHolidaysSafe = (): string[] => {
  const currentYear = getUSHolidays();
  const nextYear = getUSHolidays(moment().add(1, 'year').year());
  return [...currentYear, ...nextYear, ...getTestData()];
};

export const getUSHolidays = (year: number = moment().year()): string[] => {
  return new Holidays('US', 'DC', { types: ['public'] }).getHolidays(year).map((o) => parseHolidayDay(o));
};

export const getTestData = (): string[] => {
  if (!isTestEnv()) {
    return [];
  }

  return getDebugDataFromURL();
};

export const isTestEnv = () => {
  if (window.location.host.includes('uat') || window.location.host.includes('localhost')) {
    return true;
  }

  return false;
};

/**
 * Example usage:
 * localhost:3000/app/dcra-inspections/inspection/25799?debugTestHolidays=2024-10-30,2024-10-31,2024-11-01
 * https://uat-dcra.staging.oregon.platform-os.com/app/dcra-inspections/inspection/25799?debugTestHolidays=2024-10-30,2024-10-31,2024-11-01
 * Works only on UAT and localhost
 * @returns string[]
 */
const getDebugDataFromURL = (): string[] => {
  const url = new URL(window.location.href);
  const debug = url.searchParams.get('debugTestHolidays');
  return debug ? debug.split(',') : [];
};
